import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

import { colors } from '../../../theme/color-palette';
const {
	TOOLTIP: { HOT_SPOT },
} = colors;

export const StyledBadge = styled(Badge)((props) => ({
	'& .MuiBadge-badge': {
		backgroundColor: HOT_SPOT.BG,
		color: HOT_SPOT.BG,
		width: '16px',
		height: '16px',
		borderRadius: '50%',
		top: props.top,
		left: props.left,
		'&::after': {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			borderRadius: '50%',
			animation: 'ripple 800ms infinite ease-in-out',
			border: '1px solid currentColor',
			content: '""',
		},
		'@keyframes ripple': {
			'0%': {
				transform: 'scale(.3)',
				opacity: 1,
			},
			'100%': {
				transform: 'scale(3)',
				opacity: 0,
			},
		},
	},
}));

const HotSpot = ({ show, left, top, children }) => {
	return show ? (
		<StyledBadge variant="dot" left={left} top={top}>
			{children}
		</StyledBadge>
	) : (
		children
	);
};

HotSpot.propTypes = {
	show: PropTypes.bool,
	left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	children: PropTypes.node,
};

HotSpot.defaultProps = {
	left: 0,
	top: 0,
};

export default HotSpot;
